import { render, staticRenderFns } from "./ProjectInfoList.vue?vue&type=template&id=65604956&scoped=true&"
import script from "./ProjectInfoList.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoList.vue?vue&type=style&index=0&id=65604956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65604956",
  null
  
)

export default component.exports